var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { Button, Flex, Tooltip } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { useCalendarIntegrationsContext } from '../context/CalendarIntegrationContext';
import { useMemo, useState } from 'react';
import moment from 'moment';
import { useConfig } from '../context/ConfigContext';
import queryString from 'query-string';
import { useSafeFormData } from '../types/index';
import { useEventDateTime } from '../hooks/useDateTime';
import { useEventComposerGlobalContext } from '../composers/EventComposerGlobalContext';
import { useEditEventContext } from '../composers/EditEventContext';
import { hasAnySpaceConflicts, isUpdateButtonDisabled, rruleEndsBeforeStart, } from '../utils/validationUtils';
import { useAdvancedBookingThreshold } from '../hooks/useAdvancedBookingThreshold';
export var EditFooterButtons = function () {
    var t = useTranslation('meetingRooms').t;
    var environmentUrls = useConfig().environmentUrls;
    var dashboardUrl = environmentUrls.dashboardUrl;
    var formData = useSafeFormData();
    var startTime = formData.startTime, endTime = formData.endTime, title = formData.title, isAllDayEvent = formData.isAllDayEvent, attendeeCount = formData.attendeeCount, eventId = formData.eventId, spacesWithConflicts = formData.spacesWithConflicts;
    var _a = useEventComposerGlobalContext(), requestOnlySpace = _a.requestOnlySpace, timezone = _a.timezone, currentOrg = _a.currentOrg;
    var _b = useEditEventContext(), handleEventUpdate = _b.handleEventUpdate, updatingEvent = _b.updatingEvent, editEventError = _b.editEventError;
    var isSpaceRequestOnlyEvent = !!requestOnlySpace;
    var isStartAndEndTimeValid = useEventDateTime({ timezone: timezone }).isStartAndEndTimeValid;
    var isLoadingCalendarIntegration = useCalendarIntegrationsContext().isLoadingCalendarIntegration;
    var updateEventButtonLabel = isSpaceRequestOnlyEvent
        ? t('create_event.update_request')
        : t('create_event.update');
    var _c = __read(useState(false), 2), isRedirectingToOldComposer = _c[0], setIsRedirectingToOldComposer = _c[1];
    var someSpaceConflicts = useMemo(function () { return hasAnySpaceConflicts(spacesWithConflicts); }, [spacesWithConflicts]);
    var recurrenceEndsBeforeStart = rruleEndsBeforeStart(formData.recurrenceRule, formData.date);
    var conflictingSpaceIds = useAdvancedBookingThreshold().conflictingSpaceIds;
    var hasAbtConflict = conflictingSpaceIds.length > 0;
    var isEventValid = !someSpaceConflicts &&
        isStartAndEndTimeValid &&
        !recurrenceEndsBeforeStart &&
        !hasAbtConflict;
    var redirectToOldComposer = function () {
        var _a, _b;
        setIsRedirectingToOldComposer(true);
        var queryParams = {
            title: title,
            org: currentOrg === null || currentOrg === void 0 ? void 0 : currentOrg.id,
            started_at: startTime === null || startTime === void 0 ? void 0 : startTime.toJSON(),
            ended_at: endTime === null || endTime === void 0 ? void 0 : endTime.toJSON(),
            space_id: (_b = (_a = formData.spaces) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id,
            redirectTo: window.location.href,
            inviteeCount: attendeeCount,
            timezone: timezone || moment.tz.guess(),
            isAllDay: !!isAllDayEvent,
        };
        window.location.href = "".concat(dashboardUrl, "/event-composer/").concat(eventId, "?").concat(queryString.stringify(queryParams));
    };
    return (_jsxs(BottomRowButtons, { children: [_jsx(Tooltip, { title: recurrenceEndsBeforeStart
                    ? t('eventDetails.recurrence.ends_before_start')
                    : hasAbtConflict
                        ? t('eventDetails.recurrence.advanced_booking_threshold_conflict')
                        : !isEventValid
                            ? t('create_event.event_is_invalid')
                            : undefined, children: _jsx(Button, { variant: "dashed", type: "primary", size: "large", style: { width: '100%', flex: 1 }, onClick: function () { return handleEventUpdate(); }, loading: (updatingEvent && !editEventError) || isLoadingCalendarIntegration, disabled: isUpdateButtonDisabled({
                        isEventValid: isEventValid,
                        isRedirectingToOldComposer: isRedirectingToOldComposer,
                        isLoadingCalendarIntegration: isLoadingCalendarIntegration,
                    }), children: updateEventButtonLabel }) }), _jsx(Button, { variant: "dashed", size: "large", style: { width: '100%', flex: 1 }, onClick: function () {
                    redirectToOldComposer();
                }, loading: isRedirectingToOldComposer && !editEventError, disabled: updatingEvent || !isEventValid, children: t('create_event.more_options') })] }));
};
var BottomRowButtons = styled(Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n"])));
var templateObject_1;
